import _ from 'lodash';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { faSync } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import InputControlRow from '../../../../ui/layout/InputControlRow';
import LeftRightSplit from '../../../../ui/LeftRightSplit';
import Date from '../../../../ui/Date';
import TextBox from '../../../../ui/TextBox';
import MultilineTextBox from '../../../../ui/MultilineTextBox';
import PrimaryButton from '../../../../ui/PrimaryButton';
import IfmsModal from '../../../../ui/IfmsModal';
import useTableNavigation from '../../../../ui/tables/useTableNavigation';
import RadioButton from '../../../../ui/RadioButton';

import ApplicationContext from '../../../../ApplicationContext';
import useGlobalYesNoDialog from '../../../../hooks/useGlobalYesNoDialog';
import useGlobalOkDialog from '../../../../hooks/useGlobalOkDialog';
import useFastStorage, { useTypedFastStorage } from '../../../../hooks/useFastStorage';
import useFunction from '../../../../hooks/useFunction';
import { formatDate, now } from '../../../../dateUtils';

import { ApplicableTableSettings, billingCodeDetailList, billingCodeList } from '../../../../tableSettings';

import {
  TextAlignLeftRenderer,
  NumberedIndicatorRenderer,
  NullableCheckboxRedIconRenderer,
  DateRenderer,
  TextRenderer,
} from '../../../../uiControls/SmartTableRenderers';

import SmartTable from '../../../../uiControls/SmartTable';
import SecondaryButton from '../../../../ui/SecondaryButton';
import CheckBox from '../../../../ui/CheckBox';
import CloseButton from '../../../../ui/CloseButton';

import { checkPropDirty, getOriginalValue, getSQLInfoList } from '../../../../fms.core/data/TrackingModule';
import { TrackableEntity } from '../../../../fms.core/data/ChangeTrackable';
import { JobNames } from '../../../../framework.core/JobNames';
import { CodeBillingListItem } from '../../../../fms.data/models/CodeBillingListItem';
import useDirtyCheck from '../../../../hooks/useDirtyCheck2';
import { Search, initialSearch, isFilterObjectEmpty } from '../../../../filtering';
import { ApiResult } from '../../../../framework.core/data/ApiResult';
import GlNoLookupField from '../../../../uiControls/lookup/GlNoLookupField';
import { NCodeCharge, NCodeChargeOthers, SalesCostCode } from '../../../../fms.core/NCodeCharge';
import { historyUpdate } from '../../../../fms.data/modules/FmsModFunc';
import { SQLField, SQLInfo, SQLType } from '../../../../framework.core/data/SQLInfo';
import { getFmsGlobal } from '../../../../globals';
import { FmsSecTask } from '../../../../fms.core/constants';
import useFunctionKeys from '../../../../hooks/useFunctionKeys';
import { sortingListData } from '../../ReferenceFiles';
import { findSecurityTask } from '../../../../util';
import useFilterBar from '../../../../hooks/useFilterBar';
import { ListOrderBy } from "../../../common/AbstractListView";
import postal from 'postal';
import BlackInverseButton from '../../../../ui/BlackInverseButton';
import constants from '../../../../constants';
import IFmsReferenceFilesContext from '../../IfmsReferenceFilesContext';
import { Portal } from 'react-portal';
import EditableTable, { CellData, TableCellAligns, TableCellTypes } from '../../../../ui/tables/editing/EditableTable';
import { CodeGlNo } from '../../../../fms.core/CodeGlNo';
import AccountCodeDetails from './AccountCodeDetails';
import { layer } from '@fortawesome/fontawesome-svg-core';
import { exportCodeDataIntoExcel } from '../../../../excel';
import GreenButton from '../../../../ui/GreenButton';

function RowSpacer() {
  return (
    <div style={{ height: '10px' }}></div>
  );
}

function RowSpacer2() {
  return (
    <div style={{ height: '20px' }}></div>
  );
}
function salesCodeRenderer({ data, row, cell }: any) {
  const l = data[row.index];
  const changeLineItem = data[0].changeLineItem;
  const setCostSalesCode = data[0].setCostSalesCode;

  return (
    <GlNoLookupField
      name='biilingCode-direct-salesCode'
      maxLength={10}
      filterName='code'
      glType={'sales'}
      subType={l.shipmentType}
      opType={l.opType}
      initialValue={cell.value}
      onTextChange={sCode => changeLineItem({ 
        sCode,
        sCodeName: '',
        cCode: '',
        cCodeName: ''
       }, row.index)}
      onSelect={select => {
        changeLineItem({ sCode: select.code }, row.index);
        setCostSalesCode(select.code, l.opType, row.index);
      }}
      onBlur={async () => {
        if (!l.sCode || !l.sCodeName || l.sCode.length !== 6) {
          changeLineItem({ 
            sCode: '',
            sCodeName: '',
            cCode: '',
            cCodeName: ''
           }, row.index)
        }
      }}
    />)
}

function BillingCodeDetails({
  readonly,
  billingCode,
  onChange,
  checkSuntek
}: {
  readonly: boolean,
  billingCode: NCodeCharge,
  onChange: (change: Partial<NCodeCharge>) => void,
  checkSuntek: boolean
}) {
  const [showAccountCode, setShowAccountCode] = useState(false);
  const appContext = useContext(ApplicationContext);
  const isDefault = billingCode.isDefault;
  const canBeEdit = checkSuntek || (!checkSuntek && !isDefault);
  const listSec = findSecurityTask(appContext, FmsSecTask.CodeBillingCode);
  const canBedel = listSec.grantDel;
  const isNew = !billingCode.edit && !billingCode.view;

  const [, setHasChanges] = useFastStorage(`ifms-referenceFiles-haschanges`, false);
  const [accountCode, _setAccountCode, removeAccountCodeFromStorage, accountCodeRef] = useTypedFastStorage<CodeGlNo>(`ifms-referenceFiles-accountcode-editable`, null);
  const { setCleanState } = useDirtyCheck(`ifms-referenceFiles-accountcode-editable`, ['edit', 'view']);
  const allBillingCode = billingCode.billingCodeOthers;

  const [showGlobalOkDialog] = useGlobalOkDialog();

  useFunctionKeys({ onEsc: cancelOperation });

  function newAccountCode() { //BillingCode Detail내에 있는 new Account Code를 위함
    const newModel = new CodeGlNo();
    newModel.edit = false;
    newModel.view = false;
    setAccountCode(newModel, false);
    setCleanState(newModel);

    if (accountCodeRef.current) {
      accountCodeRef.current.trackable = true;
      setAccountCode({
        edit: false,
        view: false,
      });
    }
  }

  function setAccountCode(d: any, skipDirty: boolean = false) {
    if (!skipDirty) {
      setHasChanges(true);
    }
    _setAccountCode(d)
  }

  async function setCostSalesCode(selectCode: string, opType: string, rowIndex: number = -1) {
    const apiResult = await appContext.api.setCostSalesCode(selectCode);
    const copyModel = _.cloneDeep(billingCode.salesCostList);
    const newModel = copyModel.map((x: SalesCostCode) => {
      if (x.opType !== 'WH' && x.opType !== 'OD') {
        x.sCode = ''; x.sCodeName = ''; x.cCode = ''; x.cCodeName = '';
      }
      return x
    });
    if (apiResult !== null) {
      if (opType !== 'WH' && opType !== 'OD') {
        apiResult.forEach((element: any) => {
          let dataIndex = -1;
          const typeArray = element.glDescription.split('.');
          if (typeArray[1] === 'WH' || typeArray[1] === 'OD') return;
          dataIndex = newModel.findIndex(x => x.opType === (typeArray[1] === 'OTHR' ? 'OT' : typeArray[1]) && x.shipmentType === typeArray[2]);
          if (dataIndex !== -1) {
            if (typeArray[0] === 'SALES') {
              newModel[dataIndex].sCode = element.glNo;
              newModel[dataIndex].sCodeName = element.glDescription;
            }
            if (typeArray[0] === 'COST') {
              newModel[dataIndex].cCode = element.glNo;
              newModel[dataIndex].cCodeName = element.glDescription;
            }
          }
        });
      }
      else{
          newModel[rowIndex].sCode = '';
          newModel[rowIndex].sCodeName = '';
          newModel[rowIndex].cCode = '';
          newModel[rowIndex].cCodeName = '';

          apiResult.forEach((element: any) => {
            let dataIndex = -1;
            const typeArray = element.glDescription.split('.');
            if(typeArray[1] !== 'WH' && typeArray[1] !== 'OD') return;
            dataIndex = newModel.findIndex(x => x.opType === typeArray[1] && x.shipmentType === 'DS');
            if (dataIndex !== -1) {
              if (typeArray[0] === 'SALES') {
                newModel[dataIndex].sCode = element.glNo;
                newModel[dataIndex].sCodeName = element.glDescription;
              }
              if (typeArray[0] === 'COST') {
                newModel[dataIndex].cCode = element.glNo;
                newModel[dataIndex].cCodeName = element.glDescription;
              }
            }
          });
      }
  
      onChange({ salesCostList: newModel });
      if (!billingCode.whForView || !billingCode.btForView) checkOperation();
    }
  }

  function checkOperation() {
    const groupedByOp = billingCode.salesCostList.reduce<Record<string, number>>((acc, item) => {
      const key = item.opType;
      if (!acc[key]) {
        acc[key] = 0;
      }
      acc[key] += (item.sCode === '' && item.cCode === '' ? 1 : 0);
      return acc;
    }, {});
    onChange({
      oiForView: (allBillingCode.some(x => x.opType === 'OI') && billingCode.oiForView) || groupedByOp['OI'] !== 3,
      ooForView: (allBillingCode.some(x => x.opType === 'OE') && billingCode.ooForView) || groupedByOp['OE'] !== 3,
      aiForView: (allBillingCode.some(x => x.opType === 'AI') && billingCode.aiForView) || groupedByOp['AI'] !== 3,
      aoForView: (allBillingCode.some(x => x.opType === 'AE') && billingCode.aoForView) || groupedByOp['AE'] !== 3,
      otForView: (allBillingCode.some(x => x.opType === 'OT') && billingCode.otForView) || groupedByOp['OT'] !== 3
    });

    checkIsAll();
  }

  function changeLineItem(change: Partial<SalesCostCode>, index: number) {
    billingCode.salesCostList[index] = _.merge(billingCode.salesCostList[index], change);
    onChange({ salesCostList: billingCode.salesCostList });
  }

  const tableOptions: ApplicableTableSettings = {
    tableName: 'billingCodeDetail',
    ...billingCodeDetailList,
    height: '362px',
    data: billingCode.salesCostList.map((x, i) => ({
      ...x,
      i,
      changeLineItem,
      setCostSalesCode,
      onChange,
    })),
    rowRenderers: [
      { accessor: 'opType' },
      { accessor: 'shipmentType' },
      { accessor: 'sCode', EditCell: salesCodeRenderer },
      { accessor: 'sCodeName' },
      { accessor: 'cCode' },
      { accessor: 'cCodeName' },
    ],
    getCellData: (accessor: any, rowData: any, rowIndex: number): CellData | undefined => {
      const curRowData = rowData as SalesCostCode;
      if (accessor === 'opType')
        return { type: TableCellTypes.Text, value: curRowData.opTypeLabel, align: TableCellAligns.Center };
      else if (accessor === 'shipmentType')
        return { type: TableCellTypes.Text, value: curRowData.shipmentType, align: TableCellAligns.Center };
      else if (accessor === 'sCode')
        return { type: TableCellTypes.Text, value: curRowData.sCode };
      else if (accessor === 'sCodeName')
        return { type: TableCellTypes.Text, value: curRowData.sCodeName };
      else if (accessor === 'cCode')
        return { type: TableCellTypes.Text, value: curRowData.cCode };
      else if (accessor === 'cCodeName')
        return { type: TableCellTypes.Text, value: curRowData.cCodeName };
    },
    isCellLock: (accessor: string, rowData: any, columnIndex: number, rowIndex: number): boolean => {
      if (readonly || !canBeEdit) return true;
      if (columnIndex !== 2) return true;
      if (rowData.inActive) return true;
      else {
        // if (!billingCode.oiForView && [0, 1, 2].includes(rowIndex)) return true;
        // if (!billingCode.ooForView && [3, 4, 5].includes(rowIndex)) return true;
        // if (!billingCode.aiForView && [6, 7, 8].includes(rowIndex)) return true;
        // if (!billingCode.aoForView && [9, 10, 11].includes(rowIndex)) return true;
        // if (!billingCode.otForView && [12, 13, 14].includes(rowIndex)) return true;
        if (!billingCode.whForView && [0].includes(rowIndex)) return true;
        if(!billingCode.btForView && [1].includes(rowIndex)) return true;
        else return false;
      }
    },
    getCustomCellProps: (currentProps: any, cell: any, rowIndex: any) => {
      //if([0,1,3,4,6,7,9,10,12,13].includes(rowIndex) && cell.column.id === 'opType'){
      //   currentProps.style.borderBottom = '0px';
      //}
      // if ([3,6,9,12,15,16].includes(rowIndex)) {
      //   currentProps.style.borderTop = '1px solid lightgray';
      // }
      return currentProps;
    },
    headersColor: 'gray',
  };

  function checkIsAll() {
    if (billingCode.oiForView && billingCode.ooForView && billingCode.aiForView && billingCode.aoForView && billingCode.otForView && billingCode.whForView)
      onChange({ isAll: true });
    else
      onChange({ isAll: false });
  }

  function resetCode(opType: string, reset: boolean) {
    if (!reset) return;
    let newModel;
    if (opType === '') {
      newModel = billingCode.salesCostList.map((x: SalesCostCode) => {
        x.sCode = ''; x.sCodeName = ''; x.cCode = ''; x.cCodeName = '';
        return x
      });
    } else {
      newModel = billingCode.salesCostList.map((x: SalesCostCode) => {
        if (x.opType === opType) {
          x.sCode = ''; x.sCodeName = ''; x.cCode = ''; x.cCodeName = '';
        }
        return x
      });
    }
    onChange({ salesCostList: newModel })
  }

  async function uncheckOP(operation: string) { //EditMode에서 Operation을 uncheck하면 delete와 동일한 기능이 되므로 billingcode가 사용되고 있는지 확인해야됨
    if (isNew) return '';
    let msg = ''
    const apiResultCheck = await appContext.api.chkBCodeDelete(0, { code: billingCode.codeName + `.${operation}` });
    if (apiResultCheck && apiResultCheck.errMsg) {

      return apiResultCheck.errMsg;
    }
    return '';
  }

  //forfAccountCode
  function cancelOperation() {
    const filterNode = document.getElementById('ifms-list-screen-filter');
    const channel = postal.channel('ifms-filter');

    if (!filterNode) {
      setHasChanges(false);
      removeAccountCodeFromStorage();
      setAccountCode(null);
    } else {
      channel.publish('ifms-filter.dismiss');
    }
    return true;
  }

  return (
    <div>
      <div className="oi-doc-details-row" style={{height:'530px'}}>
        <div style={{ float: 'left', width: '320px', marginRight: '90px' , marginTop: '30px'}}>
          <InputControlRow label="* Billing Code Name" bold customFontSize={'12px'}>
            <TextBox name='billingcode-code' maxLength={(billingCode.ot === '2' || billingCode.ot === '4') ? 30 : 27} style={{ marginLeft: '15px', width: '300px' }}
              disabled={readonly || !canBeEdit} value={billingCode?.codeName || ''}
              onChange={e => onChange({ code: e.target.value, codeName: e.target.value })} placeholder={'Enter billing code name'}
              onBlur={() => {
                if (!billingCode?.description) {
                  onChange({ description: billingCode?.codeName });
                }
                if (!billingCode?.localDesc) {
                  onChange({ localDesc: billingCode?.description });
                }
              }} />
          </InputControlRow>
          <InputControlRow label="* Description (Default)" bold customFontSize={'12px'}>
            <TextBox name='billingcode-description' maxLength={100} disabled={readonly || !canBeEdit} value={billingCode?.description || ''}
              placeholder={'Enter billing code description'} style={{ marginLeft: '15px', width: '300px' }}
              onChange={e => onChange({ description: e.target.value })}
              onBlur={() => {
                if (!billingCode?.localDesc) {
                  onChange({ localDesc: billingCode?.description });
                }
              }}
            />
          </InputControlRow>
          <InputControlRow label="* Description (Customized)" bold customFontSize={'12px'}>
            <TextBox name='billingcode-descriptionCustom' maxLength={50} disabled={readonly} style={{ marginLeft: '15px', width: '300px' }}
              value={billingCode?.localDesc || ''} onChange={e => onChange({ localDesc: e.target.value })}
              placeholder={'Enter billing code description'} />
          </InputControlRow>
          <RowSpacer />
          <InputControlRow label="* Select Job Type" bold customFontSize={'12px'}>
            <div style={{ float: 'left', width: '25%', marginLeft: '15px' }}>
              <RadioButton radioId='billingcode-indexop' reverse label="Operation" disabled={readonly || !canBeEdit} checked={billingCode?.isOperation}
                onChecked={() => onChange({
                  isOperation: true,
                  isAll: false,
                  billingCodeIndex: "0",
                  sales1: '', sales1Name: '', cost1: '', cost1Name: '',
                  sales3: '', sales3Name: '', cost3: '', cost3Name: '',
                  sales5: '', sales5Name: '', cost5: '', cost5Name: '',
                  oiForView: false, ooForView: false, aiForView: false, aoForView: false, otForView: false, whForView: true, btForView:true,
                  sales6: '', sales6Name: '', cost6: '', cost6Name: '', chgType6: false,
                  isUseInInvoice: false, isUseInBill: false, isUseInWithhold: false, isUseInCorporate: false, chgType1: true, chgType3: true, chgType5: true, ot: '0'
                })
                } />
            </div>
          </InputControlRow>
          { false && 
            <>
            <div style={{ display: 'flex' }}>
              <div style={{ width: '20px' }}></div>
              
              <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ width: '60px' }}>
                  <CheckBox label='All' disabled={readonly || !billingCode?.isOperation || !canBeEdit || billingCode.whForView} value={!!billingCode?.isAll}
                    onChange={chk => {onChange({
                      isAll: chk,
                      oiForView: allBillingCode.some(x => x.opType === 'OI') ? true : chk,
                      ooForView: allBillingCode.some(x => x.opType === 'OE') ? true : chk,
                      aiForView: allBillingCode.some(x => x.opType === 'AI') ? true : chk,
                      aoForView: allBillingCode.some(x => x.opType === 'AE') ? true : chk,
                      otForView: allBillingCode.some(x => x.opType === 'OT') ? true : chk,
                      btForView: allBillingCode.some(x => x.opType === 'OD') ? true : chk,
                    });
                    if(!allBillingCode.some(x => x.opType === 'OI')) resetCode('OI', !billingCode.oiForView);
                    if(!allBillingCode.some(x => x.opType === 'OE')) resetCode('OE', !billingCode.ooForView);
                    if(!allBillingCode.some(x => x.opType === 'AI')) resetCode('AI', !billingCode.aiForView);
                    if(!allBillingCode.some(x => x.opType === 'AE')) resetCode('AE', !billingCode.aoForView);
                    if(!allBillingCode.some(x => x.opType === 'OT')) resetCode('OT', !billingCode.otForView);
                    if(!allBillingCode.some(x => x.opType === 'OD')) resetCode('OD', !billingCode.btForView);
                    }} /></div>
                <div style={{ width: '60px' }}>
                  <CheckBox label='OI' disabled={readonly || !billingCode?.isOperation || !canBeEdit || (billingCode.edit && allBillingCode.some(x => x.opType === 'OI')) || billingCode.whForView} value={billingCode.oiForView}
                    onChange={chk => {
                      onChange({
                        oiForView: chk
                      });
                      checkIsAll();
                      resetCode('OI', !billingCode.oiForView);
                    }} /></div>
                <div style={{ width: '60px' }}>
                  <CheckBox label='OE' disabled={readonly || !billingCode?.isOperation || !canBeEdit || (billingCode.edit && allBillingCode.some(x => x.opType === 'OE')) || billingCode.whForView} value={billingCode.ooForView}
                    onChange={chk => {
                      onChange({
                        ooForView: chk,
                      });
                      checkIsAll();
                      resetCode('OE', !billingCode.ooForView);
                    }} /></div>
                <div style={{ width: '60px' }}>
                  <CheckBox label='AI' disabled={readonly || !billingCode?.isOperation || !canBeEdit || (billingCode.edit && allBillingCode.some(x => x.opType === 'AI')) || billingCode.whForView} value={billingCode.aiForView}
                    onChange={chk => {
                      onChange({
                        aiForView: chk
                      });
                      checkIsAll();
                      resetCode('AI', !billingCode.aiForView);
                    }} /></div>
                <div style={{ width: '60px' }}>
                  <CheckBox label='AE' disabled={readonly || !billingCode?.isOperation || !canBeEdit || (billingCode.edit && allBillingCode.some(x => x.opType === 'AE')) || billingCode.whForView} value={billingCode.aoForView}
                    onChange={chk => {
                      onChange({
                        aoForView: chk
                      });
                      checkIsAll();
                      resetCode('AE', !billingCode.aoForView);
                    }} /></div>
              </div>
            </div>
            <RowSpacer /> 
            </>
          }
          <div style={{ display: 'flex' }}>
            <div style={{ width: '20px' }}></div>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
              {false && 
              <>
                <div style={{ width: '61px' }}></div>
                <div style={{ width: '120px' }}>
                  <CheckBox label='Other Shipment' disabled={readonly || !billingCode?.isOperation || !canBeEdit || (billingCode.edit && allBillingCode.some(x => x.opType === 'OT')) || billingCode.whForView} value={billingCode.otForView}
                    onChange={chk => {
                      onChange({
                        otForView: chk,
                      });
                      checkIsAll();
                      resetCode('OT', !billingCode.otForView);
                    }} />
                </div>
              </>
              }
                <div style={{ width: '60px' }}>
                  <CheckBox label='WareHouse (WH)' disabled={readonly || !billingCode?.isOperation || !canBeEdit || (billingCode.edit && allBillingCode.some(x => x.opType === 'WH') && !canBedel)} value={billingCode.whForView}
                    onChange={async chk => {
                        let msg = await uncheckOP('WH');
                        if (msg !== '') {
                            showGlobalOkDialog(msg);
                            return;
                        }
                    onChange({
                      whForView: chk
                    });
                    resetCode('WH', !billingCode.whForView);
                  }} /></div>

               <div style={{ width: '160px' }}>
                <CheckBox label='Brokerage Trucking (OD)' disabled={readonly || !billingCode?.isOperation || !canBeEdit || (billingCode.edit && allBillingCode.some(x => x.opType === 'OD') && !canBedel)} value={billingCode.btForView}
                  onChange={async chk => {
                    let msg = await uncheckOP('OD');
                    if (msg !== '') {
                        showGlobalOkDialog(msg);
                        return;
                    }
                    onChange({
                      btForView: chk
                    })
                    resetCode('OD', !billingCode.btForView);
                  }} /></div>
            </div>

            </div>
          <RowSpacer />
          <div style={{ clear: 'both' }}></div>
          <RowSpacer2 />
          <div style={{ float: 'left', marginLeft: '15px' }}>
            <RadioButton radioId='billingcode-indexgInvoBill' reverse label="General Bill/Invoice" disabled={readonly || !canBeEdit || (billingCode.edit && allBillingCode.length > 0)} checked={billingCode?.billingCodeIndex === "6"} 
            onChecked={() => {
              onChange({
              billingCodeIndex: "6",
              billingCodeSub: "",
              oi: "0",
              oo: "0",
              ai: "0",
              ao: "0",
              wh: "0",
              ot: "2",
              oiForView: false,
              ooForView: false,
              aiForView: false,
              aoForView: false,
              otForView: false,
              whForView: false,
              btForView: false,
              isAll: false,
              isOperation: false,
              chgType1: true,
              sales1: '',
              sales1Name: '',
              cost1: '',
              cost1Name: '',
              chgType3: false,
              cost3: '',
              cost3Name: '',
              sales3: '',
              sales3Name: '',
              chgType5: false,
              cost5: '',
              cost5Name: '',
              sales5: '',
              sales5Name: '',
              sales6: '',
              sales6Name: '',
              cost6: '',
              cost6Name: '',
              chgType6: false,
              isUseInInvoice: false,
              isUseInBill: true,
              isUseInWithhold: false,
              isUseInCorporate: false
            });  resetCode('', true)}} />
          </div>
          <div style={{ clear: 'both' }}></div>
          <div style={{ display: 'flex' }}>
            <div style={{ width: '38px' }}></div>
            <InputControlRow label="Select where this billing code is used">
              <LeftRightSplit leftSize='150px' rightSize='130px'
                left={
                  <LeftRightSplit
                    leftSize="20px"
                    rightSize="calc(100% - 20px)"
                    leftProps={{
                      style: {
                        height: '14px',
                        position: 'relative',
                        top: '-2px',
                      }
                    }}
                    left={
                      <CheckBox disabled={readonly || billingCode?.billingCodeIndex !== "6" || !canBeEdit} value={!!billingCode?.isUseInBill} onChange={isUseInBill => onChange({
                        isUseInBill,
                        cost1: isUseInBill ? billingCode.cost1 : "", cost1Name: isUseInBill ? billingCode.cost1Name : ""
                      })} />
                    }
                    right={
                      <>General Bill</>
                    }
                  />
                }
                right={
                  <LeftRightSplit
                    leftSize="20px"
                    rightSize="calc(100% - 20px)"
                    leftProps={{
                      style: {
                        height: '14px',
                        position: 'relative',
                        top: '-2px',
                      }
                    }}
                    left={
                      <CheckBox disabled={readonly || billingCode?.billingCodeIndex !== "6" || !canBeEdit} value={!!billingCode?.isUseInInvoice} onChange={isUseInInvoice => onChange({
                        isUseInInvoice,
                        sales1: isUseInInvoice ? billingCode.sales1 : "", sales1Name: isUseInInvoice ? billingCode.sales1Name : ""
                      })} />
                    }
                    right={
                      <>General Invoice</>
                    }
                  />
                }
              />
            </InputControlRow>
          </div>
          <div style={{ float: 'left', marginLeft: '15px' }}>
            <RadioButton radioId='billingcode-indexgPayroll' reverse label="Payroll" disabled={readonly || !canBeEdit || (billingCode.edit && allBillingCode.length > 0)} checked={billingCode?.billingCodeIndex === "9"} 
            onChecked={() => {onChange({
              billingCodeIndex: "9",
              billingCodeSub: "",
              oi: "0",
              oo: "0",
              ai: "0",
              ao: "0",
              wh: "0",
              ot: "4",
              oiForView: false,
              ooForView: false,
              aiForView: false,
              aoForView: false,
              otForView: false,
              whForView: false,
              btForView: false,
              isOperation: false,
              isAll: false,
              chgType1: false,
              sales1: '',
              sales1Name: '',
              cost1: '',
              cost1Name: '',
              chgType3: false,
              cost3: '',
              cost3Name: '',
              sales3: '',
              sales3Name: '',
              chgType5: false,
              cost5: '',
              cost5Name: '',
              sales5: '',
              sales5Name: '',
              chgType6: true,
              isUseInWithhold: true,
              isUseInCorporate: true,
              isUseInInvoice: false,
              isUseInBill: false,
              sales6: "211600",
              sales6Name: "PAYABLE",
              cost6: '',
              cost6Name: ''
            }); resetCode('', true)}} />
          </div>
          <div style={{ clear: 'both' }}></div>
          <div style={{ display: 'flex' }}>
            <div style={{ width: '38px' }}></div>
            <InputControlRow label="Choose where the billing code is applied to">
              <LeftRightSplit leftSize='150px' rightSize='130px'
                left={
                  <LeftRightSplit
                    leftSize="20px"
                    rightSize="calc(100% - 20px)"
                    leftProps={{
                      style: {
                        height: '14px',
                        position: 'relative',
                        top: '-2px',
                      }
                    }}
                    left={
                      <CheckBox disabled={readonly || billingCode?.billingCodeIndex !== "9" || !canBeEdit} value={!!billingCode?.isUseInWithhold} onChange={isUseInWithhold => onChange({ isUseInWithhold })} />
                    }
                    right={
                      <>Withholding</>
                    }
                  />
                }
                right={
                  <LeftRightSplit
                    leftSize="20px"
                    rightSize="calc(100% - 20px)"
                    leftProps={{
                      style: {
                        height: '14px',
                        position: 'relative',
                        top: '-2px',
                      }
                    }}
                    left={
                      <CheckBox
                        disabled={readonly || billingCode?.billingCodeIndex !== "9" || !canBeEdit}
                        value={!!billingCode?.isUseInCorporate}
                        onChange={isUseInCorporate =>
                          onChange({
                            isUseInCorporate,
                            cost6: isUseInCorporate ? billingCode.cost6 : "", cost6Name: isUseInCorporate ? billingCode.cost6Name : "",
                          })} />
                    }
                    right={
                      <>Corporate</>
                    }
                  />
                }
              />
            </InputControlRow>
          </div>
          <RowSpacer />
          <div style={{ clear: 'both' }}>
            <InputControlRow label="* Remark" bold customFontSize={'12px'}>
              <MultilineTextBox textId='biilingCode-remark' maxLength={300} style={{ height: '90px', marginLeft: '15px', width: '300px' }}
                disabled={readonly || !canBeEdit} value={billingCode?.remark || ''} onChange={e => onChange({ remark: e.target.value })} />
            </InputControlRow>
          </div>
        </div>
        <div style={{ float: 'left', width: '500px' }}>
          <RowSpacer />
          <div style={{ float: 'left', width: '120px' }}>
            <RowSpacer2 />
          </div>
          <div style={{ float: 'left', width: '500px', marginRight: '32px' }}>
            <LeftRightSplit
              leftSize="375px"
              rightSize="calc(100% - 375px)"
              left={
                <InputControlRow label="* Enter Cost/Sales Account Code" bold nocontrol customFontSize={'12px'}></InputControlRow>
              }
              right={
                <PrimaryButton disabled={billingCode.view} name='billingcode-detail-save-button' size="regular" onClick={() => { newAccountCode(); setShowAccountCode(true) }}>New Account Code</PrimaryButton>
              }
            />
            <RowSpacer />
            <div style={{ height: '356px' }}>
              {billingCode.isOperation &&
                <EditableTable tableOptions={tableOptions} deleteLine={() => { return false; }} addLine={() => { return undefined; }} />
              }
              {!billingCode.isOperation &&
                <div>
                  <LeftRightSplit
                    leftSize="85px"
                    rightSize="285px"
                    left={
                      billingCode.billingCodeIndex === "9"
                        ?
                        <InputControlRow label="Cost Code">
                          <GlNoLookupField
                            name='biilingCode-direct-costCode'
                            maxLength={10}
                            disabled={readonly || !billingCode?.chgType6 || !billingCode.isUseInCorporate || !canBeEdit}
                            filterName='code'
                            glType='payroll'
                            initialValue={billingCode.cost6}
                            onSelect={select => onChange({ validCost6: true, cost6: select.code, cost6Name: select.name })}
                            onTextChange={code => onChange({ validCost6: false, cost6: code })}
                          />
                        </InputControlRow>
                        :
                        <InputControlRow label="Cost Code">
                          <GlNoLookupField
                            name='biilingCode-direct-costCode'
                            maxLength={10}
                            disabled={readonly || !canBeEdit || !billingCode?.chgType1 || (billingCode.billingCodeIndex === "6" && !billingCode.isUseInBill)}
                            filterName='code'
                            glType={billingCode.billingCodeIndex === '6' ? 'generalCost' : 'cost'}  // <chuck date="2025-03-31" ticket="250310337" desc="expense와 income도 같이 선택할 수 있게 수정." /> // expense
                            subType={(billingCode.billingCodeIndex === '6' || billingCode.billingCodeIndex === '4') ? '' : 'DS'}
                            opType={billingCode.billingCodeIndex}
                            initialValue={billingCode.cost1}
                            onSelect={select => { onChange({ validCost1: true, cost1: select.code, cost1Name: select.name }) }}
                            onTextChange={code => onChange({ validCost1: false, cost1: code })}
                          />
                        </InputControlRow>
                    }
                    right={
                      billingCode.billingCodeIndex === "9"
                        ?
                        <InputControlRow label={<>&nbsp;&nbsp;&nbsp;&nbsp;Name</>}>
                          <TextBox disabled value={billingCode?.cost6Name || ''} />
                        </InputControlRow>
                        :
                        <InputControlRow label={<>&nbsp;&nbsp;&nbsp;&nbsp;Name</>}>
                          <TextBox disabled value={billingCode?.cost1Name || ''} />
                        </InputControlRow>
                    }
                  />
                  <LeftRightSplit
                    leftSize="85px"
                    rightSize="285px"
                    left={
                      billingCode.billingCodeIndex === "9"
                        ?
                        <InputControlRow label="Sales Code">
                          <GlNoLookupField
                            name='biilingCode-direct-salesCode'
                            maxLength={10}
                            disabled={true}
                            filterName='code'
                            initialValue={billingCode.sales6}
                          //onSelect={select => onChange({ validSales6: true, sales6: select.code, sales6Name: select.name })}
                          //onTextChange={code => onChange({ validSales6: false, sales6: code })}
                          />
                        </InputControlRow>
                        :
                        <InputControlRow label="Sales Code">
                          <GlNoLookupField
                            name='biilingCode-direct-salesCode'
                            maxLength={10}
                            disabled={readonly || !canBeEdit || !billingCode?.chgType1 || (billingCode.billingCodeIndex === "6" && !billingCode.isUseInInvoice)}
                            filterName='code'
                            glType={billingCode.billingCodeIndex === '6' ? 'generalSales' : 'sales'}   // <chuck date="2025-03-31" ticket="250310337" desc="expense와 income도 같이 선택할 수 있게 수정." /> // 'income'
                            subType='DS'
                            opType={billingCode.billingCodeIndex}
                            initialValue={billingCode.sales1}
                            onSelect={select => { onChange({ validSales1: true, sales1: select.code, sales1Name: select.name }); }}
                            onTextChange={code => onChange({ validSales1: false, sales1: code })}
                          />
                        </InputControlRow>
                    }
                    right={
                      billingCode.billingCodeIndex === "9"
                        ?
                        <InputControlRow label={<>&nbsp;&nbsp;&nbsp;&nbsp;Name</>}>
                          <TextBox disabled value={billingCode?.sales6Name || ''} />
                        </InputControlRow>
                        :
                        <InputControlRow label={<>&nbsp;&nbsp;&nbsp;&nbsp;Name</>}>
                          <TextBox disabled value={billingCode?.sales1Name || ''} />
                        </InputControlRow>
                    }
                  />
                </div>
              }
            </div>
            {checkSuntek &&
              <div style={{ width: '250px', marginLeft: '250px' ,marginTop : '50px'}}>
                <LeftRightSplit
                  leftSize="calc(100% - 115px)"
                  rightSize="115px"
                  left={
                    <div style={{ marginRight: '10px', position: 'relative', width: '110px' }}>
                      <InputControlRow
                        label={
                          <LeftRightSplit
                            leftSize="30px"
                            rightSize="calc(100% - 30px)"
                            left={
                              <CheckBox focusId='billingcode-chk-inactive' disabled={readonly || !canBeEdit} value={billingCode?.inActive || false}
                                onChange={
                                  inActive => onChange({
                                    inActive,
                                    inactiveDate: inActive ? now() : null,
                                    inactiveBy: inActive ? appContext.user?.id ?? '' : ''
                                  })
                                }
                              />
                            }
                            right={<>Inactive</>}
                          />
                        }
                      >
                        <Date dateId='billingcode-inactive-date' disabled value={billingCode?.inactiveDate ?? ''} />
                      </InputControlRow>
                    </div>
                  }
                  right={
                    <InputControlRow label="By">
                      <TextBox textId='billingcode-inactiveBy' disabled value={billingCode?.inactiveBy || ''} />
                    </InputControlRow>
                  }
                />
              </div>
            }
          </div>
        </div>
      </div>
      {!!showAccountCode && !!accountCode ? (
        <IfmsModal cancelOnEsc onCancel={cancelOperation} draggable isOpen={showAccountCode} title="Account Code New" width='1030px'>
          <AccountCodeDetails accountCodeT={accountCode ?? new CodeGlNo} reload={async () => { }} cancelOperation={cancelOperation} checkSuntek={checkSuntek}/>
        </IfmsModal>
      ) : null}
    </div>
  );
}

function formatElement(data: any, index: number) {
  return { ...data, indicator: index + 1, code: data.codeName };
}

function formatData(data: any) {
  return data.map((d: any, i: number) => formatElement(d, i));
}

function BillingCode({
  componentIndex
}: {
  componentIndex: number
}) {
  useFunction({
    invokers: {
      ifmsSettingsSave: save,
      ifmsSettingsCancel: cancelOperation,
    }
  });
  useFunctionKeys({ onEsc: cancelOperation, onSave: handleSaveAndClose });

  const appContext = useContext(ApplicationContext);
  const refContext = useContext(IFmsReferenceFilesContext);
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const { selectTableRow, tableNavigationCleanup } = useTableNavigation('billing-code-list', onRowSelect, selectBillingCodeForView, ['code'], false, false, false);

  const tableRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [, setHasChanges] = useFastStorage(`ifms-referenceFiles-haschanges`, false);
  const [data, _setData, removeData, dataRef] = useFastStorage(`ifms-referenceFiles-billingcode-list`, []);
  const [selectedRow, setSelectedRow] = useState(-1);

  const [billingCode, _setBillingCode, removeBillingCodeFromStorage, billingCodeRef] = useTypedFastStorage<NCodeCharge>(`ifms-referenceFiles-billingcode-editable`, null);
  const { setCleanState } = useDirtyCheck(`ifms-referenceFiles-billingcode-editable`, ['edit', 'view']);
  const [orderBy, setOrderBy] = useFastStorage(`ifms-referenceFiles-billingcode-orderby`, {
    orderBy: 'code',
    orderByAscending: true,
  });

  const listSec = findSecurityTask(appContext, FmsSecTask.CodeBillingCode);

  const checkSuntek = appContext.suntekSettings?.company?.companyId === "FSSUNTEK" || appContext.user?.isSuntekAdmin ? true : false;
  const tableHeight = 520;

  const FmsGlobal = getFmsGlobal();

  const { FilterButton, search } = useFilterBar(
    billingCodeList,
    undefined,
    getDefaultOrderBy,
    String(componentIndex)
  );

  function handleSaveAndClose() {
    const saveBtn = document.getElementById('detail-save-button');
    if (saveBtn) {
      saveBtn.focus();
      const modals = document.querySelectorAll('[class^="ReactModal__Content"]');
      const modalsWithoutSaveBtn = Array.from(modals).filter(modal => { return !modal.contains(saveBtn); });
      if (modalsWithoutSaveBtn.length <= 0)
        saveBtn.click();
    }
  }

  function getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'code',
      orderByAscending: true,
    };
  }

  function setData(d: any) {
    removeData();
    _setData(d);
  }

  function setBillingCode(b: any, skipDirty: boolean = false) {
    if (!skipDirty) {
      setHasChanges(true);
    }
    _setBillingCode(b);
  }

  async function fetchData(api: any, search: Search) {
    setLoading(true);

    const apiResult = await api.getListItems(JobNames.BillingCode,
      'CodeBillingListItem',
      CodeBillingListItem.calculateSearchParameters(search),
      1, search.pageSize);

    const fetchedTableData  = formatData(apiResult && apiResult.entities ? apiResult.entities : []);
    sortingListData(CodeBillingListItem, fetchedTableData , setData, orderBy);
    setHasChanges(false);
    setLoading(false);
  }

  useEffect(() => {
    if (isFilterObjectEmpty(search) && search.version === 1) reload(false);

    return () => {
      removeData();
      tableNavigationCleanup();
    };
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  useEffect(() => {
    if (loading || (isFilterObjectEmpty(search) && search.version === 1)) {
      return;
    }
    fetchData(appContext.api, search);
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [search]
  );

  useEffect(() => {
    if (dataRef.current?.length > 0 && !loading) {
      selectTableRow(0, true);
      onRowSelect(0);
    }
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [loading]
  );

  async function reload(clearAll: boolean = true) {
    const searchValue = clearAll ? initialSearch : search;
    await fetchData(appContext.api, searchValue);
  }

  function onRowSelect(rowIndex: number) {
    setSelectedRow(!isNaN(rowIndex) ? rowIndex : -1);
  }

  function onHeaderClick(header: any) {
    if (!header || !header.id || header.id === 'indicator') {
      return;
    }

    if (header && header.id !== 'indicator') {
      if (header.id === orderBy.orderBy) {
        setOrderBy({ orderByAscending: !orderBy.orderByAscending });
      } else {
        setOrderBy({ orderBy: header.id, orderByAscending: true });
      }
    }
    sortingListData(CodeBillingListItem, data, setData, orderBy);
  }

  function selectBillingCodeForNew() {
    const newModel = new NCodeCharge();
    newModel.edit = false;
    newModel.view = false;
    newModel.isOperation = true;
    newModel.whForView = true;
    newModel.btForView = true;
    setBillingCode(newModel, false);
    setCleanState(newModel);

    if (billingCodeRef.current) {
      billingCodeRef.current.trackable = true;
      setBillingCode({
        edit: false,
        view: false,
      });
    }
  }
  async function selectBillingCodeForView(row: number) {
    await setBillingCodeDetail(true, row);
  }
  async function selectBillingCodeForEdit() {
    await setBillingCodeDetail(false);
  }
  async function selectBillingCodeForDelete() {
    const doConfirm = await showGlobalYesNoDialog(
      <div>
        <h3>Confirm to Delete?</h3>
      </div>
    , false, 0, true, 'warning');
    if (doConfirm) {
      const apiResultCheck = await appContext.api.chkBCodeDelete(dataRef.current[selectedRow].id, { id: dataRef.current[selectedRow].id, pimsLinkId: 0 });
      if (apiResultCheck && apiResultCheck.errMsg) {
        showGlobalOkDialog(<p>{apiResultCheck.errMsg}</p>);
        return;
      }
      const apiResult = await appContext.api.deleteJobDetail(JobNames.BillingCode, { id: dataRef.current[selectedRow].id, pimsLinkId: 0 });
      if (apiResult && apiResult.success) {
        await reload(false);
      } else
        showGlobalOkDialog(<p>{"Cannot delete"}</p>);
    } else
      return;
  }

  async function exportExcel() {
    const apiResult = await appContext.api.getListItems(JobNames.BillingCode,
      'CodeBillingListItem',
      CodeBillingListItem.calculateSearchParameters(initialSearch),
      1, 0);

    exportCodeDataIntoExcel(apiResult.entities ?? [], `BCode-${FmsGlobal.AcmeID}`, CodeBillingListItem.getExportCollection());
  }

  async function setBillingCodeDetail(isView: boolean, row: number = -1) {
    const tempRow = row > -1 ? row : selectedRow;  // row double click시 row 값에 rowindex가 들어옴. 이를 우선시 해서 사용함.

    if (tempRow >= 0 && tempRow < dataRef.current.length && _.isEmpty(billingCode)) {
      const apiResult: ApiResult<NCodeCharge> = await appContext.api.getJobDetail(JobNames.BillingCode,
        { id: dataRef.current[tempRow].id });
      if (!apiResult || !apiResult.success) {
        await showGlobalOkDialog(<p>{apiResult?.message ?? constants.LOAD_ERROR_MESSAGE}</p>);
        return null;
      } else {
        const accountCode = { ...apiResult.result, edit: true, view: isView, editIndex: tempRow };

        const tEntity = new NCodeCharge(accountCode);

        if (tEntity.ot === '4') {
          if (!tEntity.chgType6) tEntity.chgType6 = true;
        }
        if (["0", "1", "2", "3", "4", "5"].includes(tEntity.billingCodeIndex)) {
          let sepIndex = tEntity.code.lastIndexOf('.');
          tEntity.billingCodeSub = tEntity.code.substring(sepIndex);
          tEntity.code = tEntity.code.substring(0, sepIndex);
        }
        if (tEntity.billingCodeOthers.length === 6) tEntity.isAll = true;
        if (tEntity.isOperation && !!tEntity.billingCodeOthers) {
          if (tEntity.wh === '1' || tEntity.ot === '5') {
            const types = tEntity.billingCodeOthers.map(x => x.opType);
            tEntity.whForView = types.includes('WH');
            tEntity.btForView = types.includes('OD');

            tEntity.billingCodeOthers.forEach(data => {
              if (!!data.opType) {
                if (!!data.sales1 && (data.opType === 'WH' || data.opType === 'OD')) {
                  let index = tEntity.salesCostList.findIndex(x => x.opType === data.opType && x.shipmentType === 'DS')
                  tEntity.salesCostList[index].id = data.id;
                  tEntity.salesCostList[index].sCode = data.sales1;
                  tEntity.salesCostList[index].sCodeName = data.sales1Name;
                  tEntity.salesCostList[index].cCode = data.cost1;
                  tEntity.salesCostList[index].cCodeName = data.cost1Name;
                  tEntity.salesCostList[index].inActive = data.inActive;
                }
              }
            });
          } else {
            const types = tEntity.billingCodeOthers.map(x => x.opType);
            tEntity.oiForView = types.includes('OI');
            tEntity.ooForView = types.includes('OE');
            tEntity.aiForView = types.includes('AI');
            tEntity.aoForView = types.includes('AE');
            tEntity.otForView = types.includes('OT');

            tEntity.billingCodeOthers.forEach(data => {
              if (!!data.opType) {
                if (!!data.sales1 && data.opType !== 'WH' && data.opType !== 'OD') {
                  let index = tEntity.salesCostList.findIndex(x => x.opType === data.opType && x.shipmentType === 'DS')
                  tEntity.salesCostList[index].id = data.id;
                  tEntity.salesCostList[index].sCode = data.sales1;
                  tEntity.salesCostList[index].sCodeName = data.sales1Name;
                  tEntity.salesCostList[index].cCode = data.cost1;
                  tEntity.salesCostList[index].cCodeName = data.cost1Name;
                  tEntity.salesCostList[index].inActive = data.inActive;
                }
                if (!!data.sales3 && data.opType !== 'WH' && data.opType !== 'OD') {
                  let index = tEntity.salesCostList.findIndex(x => x.opType === data.opType && x.shipmentType === 'IDS')
                  tEntity.salesCostList[index].id = data.id;
                  tEntity.salesCostList[index].sCode = data.sales3;
                  tEntity.salesCostList[index].sCodeName = data.sales3Name;
                  tEntity.salesCostList[index].cCode = data.cost3;
                  tEntity.salesCostList[index].cCodeName = data.cost3Name;
                  tEntity.salesCostList[index].inActive = data.inActive;
                }
                if (!!data.sales5 && data.opType !== 'WH'&& data.opType !== 'OD') {
                  let index = tEntity.salesCostList.findIndex(x => x.opType === data.opType && x.shipmentType === 'TS')
                  tEntity.salesCostList[index].id = data.id;
                  tEntity.salesCostList[index].sCode = data.sales5;
                  tEntity.salesCostList[index].sCodeName = data.sales5Name;
                  tEntity.salesCostList[index].cCode = data.cost5;
                  tEntity.salesCostList[index].cCodeName = data.cost5Name;
                  tEntity.salesCostList[index].inActive = data.inActive;
                }
              }
            });
          }
        }
        if (tEntity.oiForView && tEntity.ooForView && tEntity.aiForView && tEntity.aoForView && tEntity.otForView){
          tEntity.isAll = true;
        }else {
          tEntity.isAll = false;
        }
        tEntity.trackable = true;

        setCleanState(tEntity);
        setBillingCode(tEntity, false);
      }
    }
  }

  function cancelOperation() {
    const filterNode = document.getElementById('ifms-list-screen-filter');
    const channel = postal.channel('ifms-filter');

    const modals = document.querySelectorAll('[class^="ReactModal__Content"]');
    if (modals.length > 1) {
      return false;
    }

    if (!filterNode) {
      setHasChanges(false);
      removeBillingCodeFromStorage();
    } else {
      channel.publish('ifms-filter.dismiss');
    }
    return true;
  }

  async function checkDataAsync(): Promise<boolean> {
    if (!billingCode) {
      return true;
    }
    if (billingCode.isOperation) {
      if (!billingCode.oiForView && !billingCode.ooForView && !billingCode.aiForView && !billingCode.aoForView && !billingCode.otForView && !billingCode.whForView && !billingCode.btForView) {
        await showGlobalOkDialog(<p> * Please select at least one operation. </p>);
        return false;
      }
    }
    let errors = [];
    if (billingCode.code) {
      if ((billingCode.edit === false && billingCode.view === false) || getOriginalValue(billingCode, 'codeName') !== billingCode.code) {
        if (billingCode.ot === '2' || billingCode.ot === '4') { //op가 아닐때
          if (await appContext.api.checkupDuplicateFieldValueIsDuplicate("T_NCodeCharge", "F_Code", billingCode.code, "F_ID", billingCode.id)) {
            await showGlobalOkDialog(<p> * Duplicate Billing Code</p>);
            return false;
          }
        } else {//op
          if (await appContext.api.chkBCodeDup(billingCode.id, billingCode.code)) {
            await showGlobalOkDialog(<p> * Duplicate Billing Code</p>);
            return false;
          }
        }
      }
    }

    if (!billingCode.code) {
      errors.push("Must Enter Billing Code");
    }
    if (!billingCode.description) {
      errors.push("Must Enter Default Description");
    }

    if (billingCode.oiForView && billingCode.salesCostList.findIndex(x => x.opType === 'OI' && x.sCode === '') !== -1)
      errors.push('Please fill all OI Cost/Sales Account Code');
    if (billingCode.ooForView && billingCode.salesCostList.findIndex(x => x.opType === 'OE' && x.sCode === '') !== -1)
      errors.push('Please fill all OE Cost/Sales Account Code');
    if (billingCode.aiForView && billingCode.salesCostList.findIndex(x => x.opType === 'AI' && x.sCode === '') !== -1)
      errors.push('Please fill all AI Cost/Sales Account Code');
    if (billingCode.aoForView && billingCode.salesCostList.findIndex(x => x.opType === 'AE' && x.sCode === '') !== -1)
      errors.push('Please fill all AE Cost/Sales Account Code');
    if (billingCode.otForView && billingCode.salesCostList.findIndex(x => x.opType === 'OT' && x.sCode === '') !== -1)
      errors.push('Please fill all OT Cost/Sales Account Code');
    if (billingCode.whForView && billingCode.salesCostList.findIndex(x => x.opType === 'WH' && x.sCode === '') !== -1)
      errors.push('Please fill WH Cost/Sales Account Code');
    if (billingCode.btForView && billingCode.salesCostList.findIndex(x => x.opType === 'OD' && x.sCode === '') !== -1)
      errors.push('Please fill OD Cost/Sales Account Code');
    if (billingCode.ot === '4') {
      if (!billingCode.isUseInWithhold && !billingCode.isUseInCorporate)
        errors.push("Please select at least one payroll option");
      else {
        if (billingCode.isUseInCorporate && billingCode.cost6 === '')
          errors.push("Must Enter Cost Code");
        if (billingCode.sales6 === '')
          errors.push("Must Enter Sales Code");
      }
    }
    if (billingCode.ot === '2') {
      if (!billingCode.isUseInBill && !billingCode.isUseInInvoice)
        errors.push("Please select at least one option");
      else {
        if (billingCode.isUseInBill && billingCode.cost1 === '')
          errors.push("Must Enter Cost Code");
        if (billingCode.isUseInInvoice && billingCode.sales1 === '')
          errors.push("Must Enter Sales Code");
      }
    }
    // if (billingCode.cost1 && !billingCode.validCost1) {
    //   if (!await appContext.api.getFieldValue({ id: billingCode.cost1, tableName: "T_CODEGLNO", fieldName: "F_ID", idFieldName: "F_GLNO" })) {
    //     errors.push(`Invalid ${["4", "6"].includes(billingCode.billingCodeIndex) ? "" : "Direct Shipment"} Cost Code`);
    //   }
    // }
    // if (billingCode.sales1 && !billingCode.validSales1) {
    //   if (!await appContext.api.getFieldValue({ id: billingCode.sales1, tableName: "T_CODEGLNO", fieldName: "F_ID", idFieldName: "F_GLNO" })) {
    //     errors.push(`Invalid ${["4", "6"].includes(billingCode.billingCodeIndex) ? "" : "Direct Shipment"} Sales Code`);
    //   }
    // }
    // if (billingCode.cost3 && !billingCode.validCost3) {
    //   if (!await appContext.api.getFieldValue({ id: billingCode.cost3, tableName: "T_CODEGLNO", fieldName: "F_ID", idFieldName: "F_GLNO" })) {
    //     errors.push(`Invalid ${["4", "6"].includes(billingCode.billingCodeIndex) ? "" : "Indirect Shipment"} Cost Code`);
    //   }
    // }
    // if (billingCode.sales3 && !billingCode.validSales3) {
    //   if (!await appContext.api.getFieldValue({ id: billingCode.sales3, tableName: "T_CODEGLNO", fieldName: "F_ID", idFieldName: "F_GLNO" })) {
    //     errors.push(`Invalid ${["4", "6"].includes(billingCode.billingCodeIndex) ? "" : "Indirect Shipment"} Sales Code`);
    //   }
    // }
    // if (billingCode.cost5 && !billingCode.validCost5) {
    //   if (!await appContext.api.getFieldValue({ id: billingCode.cost5, tableName: "T_CODEGLNO", fieldName: "F_ID", idFieldName: "F_GLNO" })) {
    //     errors.push(`Invalid ${["4", "6"].includes(billingCode.billingCodeIndex) ? "" : "Transit Shipment"} Cost Code`);
    //   }
    // }
    // if (billingCode.sales5 && !billingCode.validSales5) {
    //   if (!await appContext.api.getFieldValue({ id: billingCode.sales5, tableName: "T_CODEGLNO", fieldName: "F_ID", idFieldName: "F_GLNO" })) {
    //     errors.push(`Invalid ${["4", "6"].includes(billingCode.billingCodeIndex) ? "" : "Transit Shipment"} Sales Code`);
    //   }
    // }
    // if (billingCode.cost6 && !billingCode.validCost6) {
    //   if (!await appContext.api.getFieldValue({ id: billingCode.cost6, tableName: "T_CODEGLNO", fieldName: "F_ID", idFieldName: "F_GLNO" })) {
    //     errors.push('Cost Code');
    //   }
    // }
    // if (billingCode.sales6 && !billingCode.validSales6) {
    //   if (!await appContext.api.getFieldValue({ id: billingCode.sales6, tableName: "T_CODEGLNO", fieldName: "F_ID", idFieldName: "F_GLNO" })) {
    //     errors.push('Sales Code');
    //   }
    // }

    if (errors.length > 0) {
      await showGlobalOkDialog(
        <div>
          <div>
            <h5>
              Error
            </h5>
          </div>
          <div>
            <ul>
              {errors.map((e, i) => <li key={i}>{e}</li>)}
            </ul>
          </div>
        </div>
        , false, null, 'error');
      return false;
    }

    return true;
  }

  function getSQLFromList(opType: string) {
    if (!billingCode) return;
    billingCode.oi = '0'; billingCode.oo = '0'; billingCode.ai = '0'; billingCode.ao = '0'; billingCode.ot = '0'; billingCode.wh = '0';
    if (opType === 'OI') billingCode.oi = '1';
    else if (opType === 'OE') billingCode.oo = '1';
    else if (opType === 'AI') billingCode.ai = '1';
    else if (opType === 'AE') billingCode.ao = '1';
    else if (opType === 'OT') billingCode.ot = '1';
    else if (opType === 'WH') billingCode.wh = '1';
    else if (opType === 'OD') billingCode.ot = '5';
    let tempList = billingCode.salesCostList.filter(x => x.opType === opType);
    billingCode.sales1 = tempList.find(x => x.shipmentType === 'DS')?.sCode ?? '';
    billingCode.sales1Name = tempList.find(x => x.shipmentType === 'DS')?.sCodeName ?? '';
    billingCode.cost1 = tempList.find(x => x.shipmentType === 'DS')?.cCode ?? '';
    billingCode.cost1Name = tempList.find(x => x.shipmentType === 'DS')?.cCodeName ?? '';
    billingCode.chgType1 = true;

    billingCode.sales3 = tempList.find(x => x.shipmentType === 'IDS')?.sCode ?? '';
    billingCode.sales3Name = tempList.find(x => x.shipmentType === 'IDS')?.sCodeName ?? '';
    billingCode.cost3 = tempList.find(x => x.shipmentType === 'IDS')?.cCode ?? '';
    billingCode.cost3Name = tempList.find(x => x.shipmentType === 'iDS')?.cCodeName ?? '';
    billingCode.chgType3 = true;

    billingCode.sales5 = tempList.find(x => x.shipmentType === 'TS')?.sCode ?? '';
    billingCode.sales5Name = tempList.find(x => x.shipmentType === 'TS')?.sCodeName ?? '';
    billingCode.cost5 = tempList.find(x => x.shipmentType === 'TS')?.cCode ?? '';
    billingCode.cost5Name = tempList.find(x => x.shipmentType === 'TS')?.cCodeName ?? '';
    billingCode.chgType5 = true;

    const fmsGlobal = getFmsGlobal();
    billingCode.sales2 = billingCode.cost5 ? (fmsGlobal.AgentAPGLNo ?? '') : "";
    billingCode.cost2 = billingCode.sales5 ? (fmsGlobal.AgentGLNo ?? '') : "";
    billingCode.chgType2 = billingCode.cost5 || billingCode.sales5 ? true : false;

    billingCode.code = (billingCode.codeName + '.' + opType);
    setBillingCode(billingCode);
    const sqlInfos = getSQLInfoList(billingCodeRef.current as TrackableEntity);
    return sqlInfos;
  }

  async function save() {
    if (!billingCode) {
      return;
    }

    if (!billingCodeRef.current?.isDirty) {
      cancelOperation();
      await reload();
      return;
    }

    const isDataValid = await checkDataAsync();
    if (!isDataValid) {
      return;
    }
    saveBillingCode();

    let sqlInfo: SQLInfo | null;
    const sqlInfoList: SQLInfo[] = [];
    sqlInfo = historyUpdate("T_CODEGLNO", billingCode.id, appContext.user?.id ?? '', billingCode.inActive ? "Inactive" : "Active");
    if (sqlInfo) {
      sqlInfoList.push(sqlInfo);
    }

    if (billingCode.isOperation) { //operation일때
      if (!billingCode.edit && !billingCode.view) { //New일때
        // if (billingCode.oiForView) {
        //   const sqlInfos = getSQLFromList('OI');
        //   if (!!sqlInfos) sqlInfoList.push(...sqlInfos);
        // }
        // if (billingCode.ooForView) {
        //   const sqlInfos = getSQLFromList('OE');
        //   if (!!sqlInfos) sqlInfoList.push(...sqlInfos);
        // }
        // if (billingCode.aiForView) {
        //   const sqlInfos = getSQLFromList('AI');
        //   if (!!sqlInfos) sqlInfoList.push(...sqlInfos);
        // }
        // if (billingCode.aoForView) {
        //   const sqlInfos = getSQLFromList('AE');
        //   if (!!sqlInfos) sqlInfoList.push(...sqlInfos);
        // }
        // if (billingCode.otForView) {
        //   const sqlInfos = getSQLFromList('OT');
        //   if (!!sqlInfos) sqlInfoList.push(...sqlInfos);
        // }
        if (billingCode.whForView) {
          const sqlInfos = getSQLFromList('WH');
          if (!!sqlInfos) sqlInfoList.push(...sqlInfos);
        }
        if (billingCode.btForView){
          const sqlInfos = getSQLFromList('OD');
          if (!!sqlInfos) sqlInfoList.push(...sqlInfos);
        }
      }
      else { //Edit일때 - 추가 및 변경만 가능
        const newModel = _.cloneDeep(billingCode.billingCodeOthers);
        billingCode.salesCostList.forEach(element => {
          if (element.sCode === '') return;
          if (newModel.some(x => x.opType === element.opType)) return;
          else {
            newModel.push(new NCodeChargeOthers({ opType: element.opType }));
          }
        });
        newModel.forEach(element => {
          if (checkPropDirty(billingCode, 'code') || checkPropDirty(billingCode, 'description') || checkPropDirty(billingCode, 'localDesc') || checkPropDirty(billingCode, 'inActive') || checkPropDirty(billingCode, 'remark')) element.changedMainprop = true;

          element.cost1 = billingCode.salesCostList.find(x => x.opType === element.opType && x.shipmentType === 'DS')?.cCode ?? '';
          element.sales1 = billingCode.salesCostList.find(x => x.opType === element.opType && x.shipmentType === 'DS')?.sCode ?? '';
          element.cost3 = billingCode.salesCostList.find(x => x.opType === element.opType && x.shipmentType === 'IDS')?.cCode ?? '';
          element.sales3 = billingCode.salesCostList.find(x => x.opType === element.opType && x.shipmentType === 'IDS')?.sCode ?? '';
          element.cost5 = billingCode.salesCostList.find(x => x.opType === element.opType && x.shipmentType === 'TS')?.cCode ?? '';
          element.sales5 = billingCode.salesCostList.find(x => x.opType === element.opType && x.shipmentType === 'TS')?.sCode ?? '';
        });
        setBillingCode({ billingCodeOthers: newModel })

        //Eidt모드에서 추가된 경우
        const ctrackableAdd = billingCode.changedCollectionProps.find(x => x.collectionName === 'billingCodeOthers')?.addedItems ?? [];
        const addItems = ctrackableAdd?.filter(x => x.changeTrackable?.sales1 !== '');
        if (!!addItems && addItems?.length > 0) {
          const fmsGlobal = getFmsGlobal();
          addItems.forEach(element => {
            var data = element.changeTrackable as NCodeChargeOthers;
            sqlInfoList.push(new SQLInfo({
              tableName: 'T_NCodeCharge',
              type: SQLType.Insert,
              fields: [
                new SQLField({ fieldName: 'F_Code', propertyName: 'code', value: (billingCode.codeName + '.' + data.opType) }),
                new SQLField({ fieldName: "F_CodeName", propertyName: "codeName", value: billingCode.codeName }),
                new SQLField({ fieldName: "f_Description", propertyName: "description", value: billingCode.description }),
                new SQLField({ fieldName: "F_LocalDesc", propertyName: "localDesc", value: billingCode.localDesc }),
                new SQLField({ fieldName: "F_Remark", propertyName: "remark", value: billingCode.remark }),
                new SQLField({ fieldName: "F_OI", propertyName: "oi", value: data.opType === 'OI' ? '1' : '0' }),
                new SQLField({ fieldName: "F_OO", propertyName: "oo", value: data.opType === 'OE' ? '1' : '0' }),
                new SQLField({ fieldName: "F_AI", propertyName: "ai", value: data.opType === 'AI' ? '1' : '0' }),
                new SQLField({ fieldName: "F_AO", propertyName: "ao", value: data.opType === 'AE' ? '1' : '0' }),
                new SQLField({ fieldName: "F_WH", propertyName: "wh", value: data.opType === 'WH' ? '1' : '0' }),
                new SQLField({ fieldName: "F_OT", propertyName: "ot", value: data.opType === 'OT' ? '1' : data.opType === 'OD' ? '5': '0' }),
                new SQLField({ fieldName: "F_ChgType1", propertyName: "chgType1", value: 1 }),
                new SQLField({ fieldName: "F_ChgType3", propertyName: "chgType3", value: 1 }),
                new SQLField({ fieldName: "F_ChgType5", propertyName: "chgType5", value: 1 }),
                new SQLField({ fieldName: "F_Sales1", propertyName: "sales1", value: data.sales1 }),
                new SQLField({ fieldName: "F_Sales3", propertyName: "sales3", value: data.sales3 }),
                new SQLField({ fieldName: "F_Sales5", propertyName: "sales5", value: data.sales5 }),
                new SQLField({ fieldName: "F_Cost1", propertyName: "cost1", value: data.cost1 }),
                new SQLField({ fieldName: "F_Cost3", propertyName: "cost3", value: data.cost3 }),
                new SQLField({ fieldName: "F_Cost5", propertyName: "cost5", value: data.cost5 }),
                new SQLField({ fieldName: "F_ChgType2", propertyName: "chgType2", value: 1 }),
                new SQLField({ fieldName: "F_Sales2", propertyName: "sales2", value: fmsGlobal.AgentAPGLNo }),
                new SQLField({ fieldName: "F_Cost2", propertyName: "cost2", value: fmsGlobal.AgentGLNo }),
                new SQLField({ fieldName: "F_inactive", propertyName: "inActive", value: billingCode.inActive }),
                new SQLField({ fieldName: "F_InactiveDate", propertyName: "inactiveDate", value: billingCode.inactiveDate }),
                new SQLField({ fieldName: "InactiveBy", propertyName: "inactiveBy", value: billingCode.inactiveBy }),
                new SQLField({ fieldName: "F_IsUseInInvoice", propertyName: "isUseInInvoice", value: billingCode.isUseInInvoice }),
                new SQLField({ fieldName: "F_IsUseInBill", propertyName: "isUseInBill", value: billingCode.isUseInBill }),
                new SQLField({ fieldName: "F_IsUseInWithhold", propertyName: "isUseInWithhold", value: billingCode.isUseInWithhold }),
                new SQLField({ fieldName: "F_IsUseInCorporate", propertyName: "isUseInCorporate", value: billingCode.isUseInCorporate }),
              ],
            }));
          });
        }

        //수정되었거나 삭제되는 경우
        const changedItems = billingCode.changedCollectionProps.find(x => x.collectionName === 'billingCodeOthers')?.changedItems ?? [];
        if (!!changedItems && changedItems?.length > 0) {
          changedItems.forEach(element => {
            var data = element.changeTrackable as NCodeChargeOthers;
            if (data.sales1 === '') //삭제됨
              sqlInfoList.push(new SQLInfo({
                type: SQLType.Delete,
                tableName: 'T_NCodeCharge',
                key: new SQLField({ fieldName: "f_id", propertyName: "id", value: data.id })
              }));
            else //수정됨
              sqlInfoList.push(new SQLInfo({
                tableName: 'T_NCodeCharge',
                type: SQLType.Update,
                fields: [
                  new SQLField({ fieldName: 'F_Code', propertyName: 'code', value: (billingCode.codeName + '.' + data.opType) }),
                  new SQLField({ fieldName: "F_CodeName", propertyName: "codeName", value: billingCode.codeName }),
                  new SQLField({ fieldName: "f_Description", propertyName: "description", value: billingCode.description }),
                  new SQLField({ fieldName: "F_LocalDesc", propertyName: "localDesc", value: billingCode.localDesc }),
                  new SQLField({ fieldName: "F_Remark", propertyName: "remark", value: billingCode.remark }),
                  new SQLField({ fieldName: "F_Sales1", propertyName: "sales1", value: data.sales1 }),
                  new SQLField({ fieldName: "F_Sales3", propertyName: "sales3", value: data.sales3 }),
                  new SQLField({ fieldName: "F_Sales5", propertyName: "sales5", value: data.sales5 }),
                  new SQLField({ fieldName: "F_Cost1", propertyName: "cost1", value: data.cost1 }),
                  new SQLField({ fieldName: "F_Cost3", propertyName: "cost3", value: data.cost3 }),
                  new SQLField({ fieldName: "F_Cost5", propertyName: "cost5", value: data.cost5 }),
                  new SQLField({ fieldName: "F_inactive", propertyName: "inActive", value: billingCode.inActive }),
                  new SQLField({ fieldName: "F_InactiveDate", propertyName: "inactiveDate", value: billingCode.inactiveDate }),
                  new SQLField({ fieldName: "InactiveBy", propertyName: "inactiveBy", value: billingCode.inactiveBy }),
                ],
                key: new SQLField({ fieldName: "f_id", propertyName: "id", value: data.id })
              }));
          });
        }
      }
    } else {
      const sqlInfos = getSQLInfoList(billingCode as TrackableEntity);
      sqlInfoList.push(...sqlInfos);
    }

    const apiResult = await appContext.api.saveJobDetail(JobNames.BillingCode, sqlInfoList);

    if (apiResult) {
      await showGlobalOkDialog(<p>The data has been saved</p>);

      cancelOperation();
      await reload(false);
    }
  }

  function saveBillingCode() {
    if (!billingCode) return;

    const fmsGlobal = getFmsGlobal();
    const mainChange: Partial<NCodeCharge> = {};

    mainChange.sales2 = billingCode.cost5 ? fmsGlobal.AgentAPGLNo : "";
    mainChange.cost2 = billingCode.sales5 ? fmsGlobal.AgentGLNo : "";
    mainChange.chgType2 = billingCode.cost5 || billingCode.sales5 ? true : false;

    mainChange.localDesc = billingCode.localDesc;

    if (mainChange.localDesc.length > 50) {
      mainChange.localDesc = billingCode.localDesc.substring(0, 50);
    }
    if (!_.isEmpty(mainChange)) {
      setBillingCode(mainChange);
    }
  }

  const tableOptions: ApplicableTableSettings = {
    customTableId: 'billing-code-list',
    ref: tableRef,
    selectable: true,
    tableName: 'billing-code-list',
    ...billingCodeList,
    height: `${tableHeight}px`,
    data: data.map((x: any) => ({ ...x })),
    rowRenderers: [
      { accessor: 'indicator', Cell: NumberedIndicatorRenderer },
      { accessor: 'code', Cell: TextAlignLeftRenderer },
      { accessor: 'desc1', Cell: TextAlignLeftRenderer },
      { accessor: 'jobType', Cell: TextAlignLeftRenderer },
      { accessor: 'localDesc', Cell: TextAlignLeftRenderer },
      { accessor: 'salesGLNo', Cell: TextRenderer },
      { accessor: 'salesGLNoDesc', Cell: TextAlignLeftRenderer },
      { accessor: 'costGLNo', Cell: TextRenderer },
      { accessor: 'costGLNoDesc', Cell: TextAlignLeftRenderer },
      { accessor: 'inactive', Cell: NullableCheckboxRedIconRenderer },
      { accessor: 'inactiveDate', Cell: DateRenderer },
      { accessor: 'remark', Cell: TextAlignLeftRenderer },
    ],
    orderBy: [orderBy],
    onHeaderClick,
  };

  //const billingCodeCount = data ? data.length : 0;
  const hasSelectedRow = !isNaN(selectedRow) && !(selectedRow < 0);
  const canBeAdd = listSec?.grantAdd;
  const canBeEdit = hasSelectedRow && listSec?.grantEdit;
  const canBeDeleted = hasSelectedRow && listSec?.grantDel && (checkSuntek || (!!dataRef?.current && !dataRef?.current[selectedRow]?.isDefault));

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const RenderedTable = React.useMemo(() => <SmartTable {...tableOptions} />, [dataRef.current]);

  return (
    <div style={{ marginTop: '40px' }}>
      {/* <Portal node={document && document.getElementById('settings-placeholder')}>
        <h1>Codes <FontAwesomeIcon icon={faAngleRight} /> Billing Code</h1>
        <div style={{width: '350px', fontWeight: 'bold'}}>
          <ClearableSearch initialValue={orderBy?.generalText1 || ''} onSearch={generalText1 => {
            setOrderBy({general1: generalText1 ? orderBy?.orderBy : null, generalText1})
            reload();
          }} />
        </div>
      </Portal>   */}
      {/* <div style={{ width: '350px', fontWeight: 'bold', marginTop: '20px' }}>
        <ClearableSearch
          initialValue={orderBy?.generalText1 || ''}
          onSearch={async generalText1 => {
            await reload(generalText1 === null ? '' : generalText1);
          }}
        />
      </div> */}

      <Portal node={document && document.getElementById('settings-command-placeholder')}>
        <div style={{ display: 'flex', marginTop: '5px' }}>
          <div className="ifms-common-bar-element" style={{ marginLeft: '66px' }}>
            <CloseButton name='settings-close' mode='light' onClick={refContext.cancel} />
          </div>
        </div>
      </Portal>

      {/*  
      <Portal node={document && document.getElementById('settings-command-placeholder')}>
        <GreenButton size="regular" disabled={loading} onClick={reload}>
              Refresh
        </GreenButton>&nbsp;
      </Portal> */}

      <div>
        <div style={{ display: 'flex', width: '1350px' }}>
          {/* <div style={{marginLeft: '30px', fontSize: '11px', fontWeight: 'bold'}}>
              ** Total Number of Billing Code: {billingCodeCount} **
            </div> */}
          <div style={{ marginLeft: 'auto' }}></div>
          <div style={{ position: 'relative', top: '-4px'}}>
            <div style={{ display: 'none' }}>
              <FilterButton /> &nbsp;&nbsp;
            </div>
            <SecondaryButton name='codes-billingcode-add-button' size="regular" disabled={!canBeAdd} onClick={selectBillingCodeForNew}>New</SecondaryButton>
            &nbsp;&nbsp;
            <SecondaryButton name='codes-billingcode-view-button' size="regular" disabled={!hasSelectedRow} onClick={selectBillingCodeForView}>View</SecondaryButton>
            &nbsp;&nbsp;
            <SecondaryButton name='codes-billingcode-edit-button' size="regular" disabled={!canBeEdit} onClick={selectBillingCodeForEdit}>Edit</SecondaryButton>
            &nbsp;&nbsp;
            <SecondaryButton name='codes-billingcode-delete-button' size="regular" disabled={!canBeDeleted} onClick={selectBillingCodeForDelete}>Delete</SecondaryButton>
            &nbsp;
            {checkSuntek &&
              <>
                &nbsp;
                <SecondaryButton name='codes-billingcode-delete-button' size="regular" onClick={exportExcel}>Export</SecondaryButton>
                &nbsp;
              </>
            }
            <BlackInverseButton name='list-screen-refresh' disabled={loading} size="large" onClick={() => { cancelOperation(); reload(false); }} data-tooltip="Refresh" >
              <FontAwesomeIcon color='#47C83E' icon={faSync} />
            </BlackInverseButton>
          </div>
        </div>
        <div style={{ width: '1350px' }}>
          {RenderedTable}
        </div>
      </div>
      <IfmsModal isOpen={!!billingCode} draggable title={billingCode && billingCode.edit ? (billingCode.view ? 'Billing Code View' : 'Billing Code Edit') : 'Billing Code & Account Code New'} onCancel={cancelOperation} width='970px'>
        {!!billingCode &&
          <div>
            <div style={{ display: 'flex' }}>
              <div style={{ marginLeft: 'auto' }}></div>
              <div className="ifms-common-bar-element ifms-right-separator-light-gray">
                &nbsp;
                {billingCode.view && listSec?.grantEdit &&
                  <PrimaryButton name='billingcode-detail-edit-button' size="regular" onClick={() => setBillingCode({ view: false }, true)}>Edit</PrimaryButton>
                }
                {!billingCode.view &&
                  <GreenButton name='billingcode-detail-save-button' size="regular" onClick={save}>Save</GreenButton>
                }
                &nbsp;
              </div>
              <div className="ifms-common-bar-element">
                <CloseButton name='billingcode-detail-close-button' onClick={cancelOperation} />
              </div>&nbsp;&nbsp;
            </div>
            <BillingCodeDetails readonly={billingCode.view} billingCode={billingCode} onChange={setBillingCode} checkSuntek={checkSuntek} />
            <div style={{ clear: 'both' }}></div>
          </div>
        }
      </IfmsModal>
    </div>
  );
}

export default BillingCode;
